import { useState } from "react";

import EntityTable from "./Listing/EntityTable";
import NewInvoiceModal from "./Modal/NewInvoiceModal";
import CreateReturnModal from "./Modal/CreateReturnModal";

import useOrderColumns from "../hooks/orderColumns";
import { API_BASE_URL } from '../api';

const ProductOrders = ({ product, onCountChange }) => {
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showNewInvoiceModal, setShowNewInvoiceModal] = useState(false);
  const [showCreateReturnModal, setShowCreateReturnModal] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  const columns = useOrderColumns({
    onNewInvoice: (row) => {
      setSelectedOrder(row);
      setShowNewInvoiceModal(true);
    },
    onCreateReturn: (row) => {
      setSelectedOrder(row);
      setShowCreateReturnModal(true);
    },
    onReload: () => {
      setReloadKey((prev) => prev + 1);
    },
  });

  return (
    <>
      <EntityTable
        key={reloadKey}
        endpoint={`${API_BASE_URL}/api/v1/getOrders`}
        columns={columns}
        extraParams={{
          productId: product.id
        }}
        pageSize={10}
        emptyMessage="Aucune vente"
        searchable={true}
        multiSelect={false}
        onTotalChange={onCountChange}
      />

      <NewInvoiceModal
        order={selectedOrder}
        show={showNewInvoiceModal}
        onClose={() => setShowNewInvoiceModal(false)}
      />

      <CreateReturnModal
        order={selectedOrder}
        show={showCreateReturnModal}
        onClose={() => { setShowCreateReturnModal(false); setSelectedOrder(null); }}
        onSave={() => setReloadKey((prev) => prev + 1)}
      />
    </>
  );
};

export default ProductOrders;
